// extracted by mini-css-extract-plugin
export var background = "menu-sidebar-module--background--0DElj";
export var logo = "menu-sidebar-module--logo--ylK+L";
export var logoIcon = "menu-sidebar-module--logo-icon--UN0-q";
export var nav = "menu-sidebar-module--nav--fmFjX";
export var open = "menu-sidebar-module--open--Udv4r";
export var sidebar = "menu-sidebar-module--sidebar--xIBgi";
export var toggle = "menu-sidebar-module--toggle--T2ZOp";
export var toggleIcon = "menu-sidebar-module--toggle-icon--4d1RG";